import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/CaretLeft.svg'

export const IconCaretLeft = IconSVG as IconComponent
